import { useDispatch } from 'react-redux';
import { useDispatchRawVestaMinter } from './slices/rawVestaMinter/useDispatchRawVestaMinter';
import { AppDispatch } from 'store';

export const useCustomDispatch = () => {
  const dispatch = useDispatch<AppDispatch>();
  const dispatchRawVesta = useDispatchRawVestaMinter();

  const dispatchRawVestaMinter = () => {
    dispatchRawVesta.dispatchAll();
  };

  return {
    dispatchRawVestaMinter
  };
};
